import { firestore } from 'src/config/firebaseClient';
import {
  collectionGroup,
  getDocs,
  limit,
  query,
  where,
} from 'firebase/firestore';
import { ConverterFactory } from 'functions/src/util/firestore/ConverterFactory';
import { User } from 'functions/src/types/firestore/User';

export const getUsername = async (email: string) => {
  const userRef = query(
    collectionGroup(firestore, 'UserProfile'),
    where('email', '==', email),
    limit(1),
  ).withConverter(ConverterFactory.buildDateConverter<User<Date>>());
  const userDoc = await getDocs(userRef);
  if (userDoc.empty) {
    return;
  }
  const userData = userDoc.docs[0].data();
  return userData.username;
};
